export const truncateLabel = (label: string, length: number) => {
  return label.length > length ? label.substring(0, length) + '...' : label;
};
